import * as XLSX from 'xlsx';
import moment from 'moment';

const DownloadExcel = (data, filename) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, filename);
    XLSX.writeFile(workbook, `${moment().milliseconds() + 1000 * (moment().seconds() + 60 * 60) + `-${filename}`}.xlsx`);
    return true;
};

const SampleFileDownload = (sectionName) => {

    let fileUrl = process.env.PUBLIC_URL;
    
    console.log(fileUrl, "fileUrl");

    if (sectionName === 'Service') {
        fileUrl += '/service-sample.xlsx';   
    } else if (sectionName === 'User') {
        fileUrl += '/user-sample.xlsx';   
    }

    const link      =   document.createElement('a');
    link.href       =   fileUrl;
    link.download   =   'sample.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export { DownloadExcel, SampleFileDownload };
